import { SadaShowMobile } from './styles';

const ShowMobile = (props) => <SadaShowMobile {...props} />;

export default ShowMobile;
